export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#0B4F8A" />
    <path d="M32 11 L51 49 L32 40.5 L13 49 Z" fill="#FFFFFF" />
    <path d="M32 40.5 L32 22" stroke="#38BDF8" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className={`font-display leading-none ${dark ? "text-white" : "text-ink"}`}>
      <span className="block text-[17px] font-semibold tracking-tight">Aero Soft</span>
      <span className={`block font-mono text-[10px] uppercase tracking-[0.28em] ${dark ? "text-sky-300" : "text-sky-700"}`}>
        Solutions
      </span>
    </span>
  </span>
);
